module.exports = __webpack_public_path__ + "img/func-keypal-3.f920c09f.png";